import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactQuill from 'react-quill';
import Switch from "react-switch";
import { modules, formats } from '../../../constants';
import CloseIcon from '../../../imgs/close-icon.svg';
import IconClip from '../../../imgs/icon-clip.svg';
import ImageIcon from '../../../imgs/image-icon.svg';
import PDFIcon from '../../../imgs/pdf-icon.svg';

class InputWithEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: !!props.value,
      focused: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { value } = this.props;

    if(nextProps.value && value !== nextProps.value)
      this.setState({ checked: !!nextProps.value });
  }

  onTextChange = content => {
    this.props.onChange(content);
  }

  onFocus = () => {
    this.props.onFocus(this.props.name);
    this.setState(({ focused: true }), () => {
      this.quillEditor.focus();
    });
  }

  onBlur = () => {
    this.props.onBlur();
    this.setState({ focused: false });
  }

  onToggleSwitch = () => {
    this.props.onChange('');
    this.setState({ checked: !this.state.checked, focused: false });
  }

  render() {
    const { checked, focused } = this.state;
    const {
      title,
      value,
      className,
      placeholder,
      isAnotherInputFocused,
      name,
      disableToggle,
      consultationAttachmentsToDisplay,
      addConsultationAttachment,
      removeConsultationAttachment
    } = this.props;
    const sectionAttachments = consultationAttachmentsToDisplay ? consultationAttachmentsToDisplay.filter(attachment => attachment.section === name) : [];

    return (
      <div style={{marginBottom: '40px'}}>  
        <div className={ `editor-${ className } editor-w` }>
          <div className="editor-w--toggle">
            <Switch
              checked={ checked }
              onChange={ this.onToggleSwitch }
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={ 30 }
              uncheckedIcon={ false }
              checkedIcon={ false }
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={ 20 }
              width={ 48 }
              className="react-switch"
              disabled={ disableToggle }
            />
          </div>
          <div className="editor-w--label">{ title }</div>
          <div className="editor-w--editor">
            { focused && isAnotherInputFocused === name ?
              <ReactQuill
                name={ name }
                ref={ ref => this.quillEditor = ref }
                placeholder={ placeholder }
                value={ value || '' }
                onChange={ this.onTextChange }
                modules={ modules }
                formats={ formats }
                className={ `hide-border quill-toolbar-position` }
              /> :
              <div className='ql-editor' tabIndex="0" onFocus={ this.onFocus } disabled={ !checked }>
                <span>{ value && checked ? ReactHtmlParser(value) : (checked ? placeholder : 'Turned off') }</span>
              </div>
            }
          </div>
        </div>

      { sectionAttachments &&
        sectionAttachments.length > 0 &&
          <div className="rightnow--attachments">
            { sectionAttachments.map((attachment, index) =>
              <div key={ index } className="attachment-single">
                <img src={ attachment.attachment_content_type === 'application/pdf' || (attachment.document_file_name && attachment.document_file_name.match('pdf')) ? PDFIcon : ImageIcon } alt="file icon" />
                <span>{ attachment.name || attachment.document_file_name }</span>
                <button className="like-text" onClick={ () => removeConsultationAttachment(index) }>
                  <img src={ CloseIcon } alt="delete" />
                </button>
              </div>
            )}
          </div>
        }
        <div className="rightnow--buttons">
          { sectionAttachments &&
            sectionAttachments.length === 3 ?
            <div className="clip-block">
              <button className="like-text" disabled>
                <div>
                  <img src={ IconClip } alt="add file"/>
                  <span>3 maximum</span>
                </div>
              </button>
            </div> :
            <div className="clip-block">
              <input
                id={name}
                type='file'
                style={{ display: 'none' }}
                className="like-text"
                onChange={ addConsultationAttachment }
              />
              <div>
                <label htmlFor={name}>
                  <img src={ IconClip } alt="add file"/>jpg png pdf doc docx
                </label>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default InputWithEditor;